import { api } from './axios';

export interface DashboardSummary {
  asOf: string;
  role: string;
  students: { total: number; active: number; suspended: number; left: number; graduated: number; newEnrolledThisMonth: number };
  staff: { total: number; active: number };
  studentAttendanceToday: AttendanceTodayBlock;
  staffAttendanceToday: AttendanceTodayBlock;
  fees: { collectedToday: number; collectedThisMonth: number; outstanding: number; defaulterCount: number };
  inventory: { lowStockCount: number; openMovementsCount: number };
  frontDesk: { openComplaints: number; inquiriesThisMonth: number; visitorsToday: number };
  academics: { upcomingExamsThisWeek: number; activeClasses: number; activeSubjects: number };
  classBreakdown: ClassEnrollmentRow[];
  recentNotices: { id: number; title: string; category: string; postedAt: string }[];
}

export interface AttendanceTodayBlock {
  expected: number; present: number; absent: number; late: number; onLeave: number;
}

export interface ClassEnrollmentRow {
  classSectionId: number; className: string; sectionName: string; sortOrder: number; studentCount: number;
}

export const dashboardApi = {
  summary: () => api.get<DashboardSummary>('/dashboard/summary').then((r) => r.data),
};
